export let PAYOR_FILTERS = {
  EXISTING: 'EXISTING',
  NEW: 'NEW',
}
